import type {
  GetPropsFiltersPayload,
  SlipStatus,
} from '../../services/interfaces/propsService/api';
import type { PropPickProps } from '../../common/types/propPickProps.type';

const QuickPickQueryKeys = {
  QUICK_PICKS: (filters?: GetPropsFiltersPayload) => ['quick-picks', filters].filter(Boolean),
  QUICK_PICKS_V1: (filters?: GetPropsFiltersPayload) => ['quick-picks-v1', filters].filter(Boolean),
  QUICK_PICKS_SEARCH_V1: (filters?: GetPropsFiltersPayload) =>
    ['quick-picks-search-v1', filters].filter(Boolean),
  QUICK_PICKS_FILTERS: () => ['quick-picks-filters'],
  QUICK_PICKS_SETTINGS: (locationState: string) => ['quick-picks-settings', locationState],
  QUICK_PICKS_LOCATION_ALLOWED: () => ['quick-picks-location-allowed'],
  QUICK_PICKS_SLIPS_QUERY_PREFIX: ['quick-picks-slips'] as const,
  QUICK_PICKS_SLIPS: (include: SlipStatus[], parentId?: string) =>
    ['quick-picks-slips', include, parentId ?? null] as const,
  QUICK_PICKS_SLIP: (id: string) => ['quick-picks-slip', id],
  QUICK_PICKS_GROUP_SLIP: (groupId: string, slipId: string) => [
    'quick-picks-group-slip',
    groupId,
    slipId,
  ],
  QUICK_PICKS_LEADERBOARD_SLIPS: (groupId: string) => ['quick-picks-leaderboard-slips', groupId],
  QUICK_PICKS_PLAYER: (id: string) => ['quick-picks-player', id],
  QUICK_PICKS_GROUP_SLIP_ENTRIES: (groupId: string) => ['quick-picks-group-slip-entries', groupId],
  CREATE_SLIP: () => ['create-slip'],
  VALIDATE_BOOST: () => ['validate-boost'],
  VALIDATE_VOUCHER: () => ['validate-voucher'],
  QUICK_PICKS_GET_PROPS_BY_IDS: (propsIds: string) => ['quick-picks-get-props-by-ids', propsIds],
  QUICK_PICKS_DISCOVER: (disallowed?: string[]) => [
    'quick-picks-discover',
    disallowed,
  ],
  QUICK_PICKS_POPULAR: (disallowed?: string[]) => [
    'quick-picks-popular',
    ...(disallowed ?? []).sort(),
  ],
  QUICK_PICKS_SEARCH_POPULAR: (disallowed?: string[]) => [
    'quick-picks-search-popular',
    ...(disallowed ?? []).sort(),
  ],
  QUICK_PICKS_POPULAR_ALL: () => ['quick-picks-popular'] as const,
  QP_PAYOUTS: (picks: PropPickProps[], isQuickPicksV2?: boolean) => [
    'qp-payouts',
    picks
      .map((p) => `${p.id}-${p.direction}`)
      .sort()
      .join('|'),
    // Appended so v1/v2 previews (different request payloads) never share a
    // cache entry. Invalidation callers omit it and still match by key prefix.
    ...(isQuickPicksV2 === undefined ? [] : [isQuickPicksV2]),
  ],
};

export const POLL_INTERVAL = 300_000;
export const SHORT_CACHE_TIME = 100;

export default QuickPickQueryKeys;
